<template>
  <div>
    <div class="scenario_result">
      <div class="s-result_top retiremod">
        <div class="container">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link to="https://www.smartbeb.com.tw">首頁</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link to="/needs_analysis">人生藍圖計算機</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{name: 'retire'}">退休試算</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">試算結果</li>
            </ol>
          </nav>
          <div class="s-result_top--img">
            <img src="@/assets/images/needs/banner-retire/form_people2.svg" alt=""/>
          </div>
          <div class="s-result_top--text">
            <h3>退休共需花費</h3>
            <p>{{ result.wantCostAfterRetirePerMonth | currency }}<span> 元／月</span></p>
          </div>

          <div class="s-result_top--btn row">
            <div class="col-xs-6 col-md-2 col-md-offset-4 form-group">
              <div class="share_btn share_btn_blue">
                <a href="" @click.prevent="backRetireForm()">重新試算</a>
              </div>
            </div>
            <div class="col-xs-6 col-md-2 form-group">
              <div class="share_btn share_btn_blueDefault">
                <a href="" class="click_needs_analysis_consult_top"
                  @click.prevent="toForm('客製化搭配')">我想了解</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="s-result_content">
        <div class="container">
          <div class="s-result_content--chart">
            <div class="chart_wrap">
              <div class="donuts_chart">
                <canvas id="ScenarioresultChart"></canvas>
                <div class="donuts_chart_rate">
                  <p>退休準備完成度</p>
                  <span class="sm-percent">{{ result.retireDoneRate }}%</span>
                </div>
                <div v-show="result.retireDoneRate >= 90 || result.retireNeedMonth <= 1500"
                     class="retire--message-container">
                  <div class="retire--message-1">
                    恭喜你快要可以退休囉！
                    <div class="retire--triangle"></div>
                  </div>
                  <p class="retire--message-2">別忘記也要擔心自己的<a href="#s-result_sup" style="text-decoration:underline;">保險配置</a></p>
                </div>
              </div>
              <div class="chart_formula fixed-oversize">
                <div class="formula_summary">
                  <div class="title_coin">
                    <img src="@/assets/images/needs/banner-retire/coin.svg" alt=""/>
                  </div>
                  <div class="formula_title">
                    退休藍圖試算結果
                  </div>
                  <month_cost
                      :travel="travel"
                      :trans="trans"
                      :food="food"
                      :normal="normal"
                      @updateResult="updateResult($event)"
                  ></month_cost>
                </div>
                <div class="formula_content">
                  <div class="col-xs-12 col-md-12">
                    <div class="content_block solid_line Amod">
                      <p class="block_title">應備退休金總額</p>
                      <p class="block_num">
                        {{ result.costAfterRetire | currency }}
                        <span> 元</span>
                      </p>
                    </div>
                  </div>
                  <div class="col-xs-12 col-md-4">
                    <div class="content_block dash_line Bmod">
                      <p class="block_title">已備退休金</p>
                      <p class="block_num">
                        {{ result.formData_alreadyPrepare | currency }}
                        <span> 元</span>
                      </p>
                    </div>
                  </div>
                  <div class="col-xs-12 col-md-4">
                    <div class="content_block dash_line Cmod">
                      <p class="block_title have-desc">
                        勞保
                        <i
                            content="勞保 = 平均月投保薪資 x 給付月數"
                            v-tippy="{arrow : true, arrowType : 'round', placement: 'bottom'}"
                            class="fas fa-question h-insurance">
                        </i>
                      </p>
                      <p class="block_num">
                        {{ result.laborProtectionAmount | currency }}
                        <span> 元</span>
                      </p>
                    </div>
                  </div>
                  <div class="col-xs-12 col-md-4">
                    <div class="content_block dash_line Dmod">
                      <p class="block_title have-desc">
                        勞退
                        <i
                            class="fas fa-question h-refund"
                            content="勞退 = ( 工資 x 6% x 12個月 x 年資 ) + 投資累積收益"
                            v-tippy="{arrow : true, arrowType : 'round', placement: 'bottom'}">
                        </i></p>
                      <p class="block_num">
                        {{ result.laborRebateAmount | currency }}
                        <span> 元</span>
                      </p>
                    </div>
                  </div>
                  <div class="col-xs-12 col-md-12">
                    <div class="content_block solid_line Emod">
                      <p class="block_title">補足退休金缺口應再存</p>
                      <p class="block_num">
                        {{ result.retireNeedMonth | currency }}
                        <span> 元／月</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="s-result_detail">
        <div class="container">
          <div
              @click="
              showDetail = !showDetail;
              drawXYAxis();
            "
              class="click_needs_analysis_seeDetail s-result_detail--btn"
          >
            想早點退休？展開看詳解
            <i class="fas fa-chevron-down" :class="{ 'btn--active': showDetail }"></i>
          </div>
          <transition name="fade">
            <div v-show="showDetail">
              <div class="s-result_detail--body">
                <h3>達成理想生活的收支配比，通常是...</h3>

                <div class="s-result_detail--form">
                  <div class="detail--form-title">
                    <div class="icon-wrapper">
                      <i class="fas fa-dollar-sign icon--blue"></i>
                      <p class="icon-text text--blue">保險</p>
                    </div>

                    <i class="fas fa-plus"></i>

                    <div class="icon-wrapper">
                      <i class="fas fa-dollar-sign icon--orange"></i>
                      <p class="icon-text text--orange">儲蓄</p>
                    </div>

                    <i class="fas fa-plus"></i>

                    <div class="icon-wrapper">
                      <i class="fas fa-dollar-sign icon--red"></i>
                      <p class="icon-text text--red">開銷</p>
                    </div>
                  </div>

                  <div class="detail--form--diagram">
                    <!-- 圖表在小螢幕時 -->
                    <div class="diagram-on-small">
                      <div class="most-people detail--form-item">
                        <img class="detail-item__img" src="@/assets/images/needs/banner-retire/icon_girl.svg" alt=""/>
                        <p class="bar-text">多數人的配比</p>
                      </div>

                      <div class="most-people--bar">
                        <div
                            class="progress-bar stripe-blue"
                            :style="{ width: mostPeople.bar1 + '%' }"
                        >
                          {{ mostPeople.bar1 }}%
                        </div>
                        <div
                            class="progress-bar stripe-orange"
                            :style="{ width: mostPeople.bar2 + '%' }"
                        >
                          {{ mostPeople.bar2 }}%
                        </div>
                        <div
                            class="progress-bar stripe-red"
                            :style="{ width: mostPeople.bar3 + '%' }"
                        >
                          {{ mostPeople.bar3 }}%
                        </div>
                      </div>

                      <div class="recommend-adjust detail--form-item">
                        <img class="detail-item__img" src="@/assets/images/needs/banner-retire/icon_dog.svg" alt=""/>
                        <p class="bar-text">依你的退休期待，我們建議的配比</p>
                        <i
                            class="fas fa-question"
                            :content="recommend.tip"
                            v-tippy="{arrow : true, arrowType : 'round', placement: 'bottom', allowHTML: true}"
                        >
                        </i>
                      </div>

                      <div class="recommend-adjust--bar">
                        <div class="progress-bar solid-blue"
                             :style="{ width: insuranceBarPercent + '%' }"
                             :content="recommend.insurance | tip_currency"
                             v-tippy="{arrow : true, arrowType : 'round', placement: 'top'}"
                        >
                          {{ insuranceBarPercent }}%
                        </div>
                        <div
                            v-if="savingBarPercent > 0"
                            class="progress-bar solid-orange"
                            :style="{ width: savingBarPercent + '%' }"
                            :content="recommend.saving | tip_currency"
                            v-tippy="{arrow : true, arrowType : 'round', placement: 'top'}"
                        >
                          {{ savingBarPercent }}%
                        </div>
                        <div class="progress-bar solid-red"
                             :style="{ width: dailyCostBarPercent + '%' }"
                             :content="recommend.dailyCost | tip_currency"
                             v-tippy="{arrow : true, arrowType : 'round', placement: 'top'}"
                        >
                          {{ dailyCostBarPercent }}%
                        </div>
                      </div>
                    </div>

                    <!-- 圖表在大螢幕時 -->
                    <div class="diagram-on-big">
                      <div class="item-wrapper">
                        <div class="most-people detail--form-item">
                          <img class="detail-item__img" src="@/assets/images/needs/banner-retire/icon_girl.svg" alt=""/>
                          <p class="bar-text">多數人的配比</p>
                        </div>

                        <div class="recommend-adjust detail--form-item">
                          <img class="detail-item__img" src="@/assets/images/needs/banner-retire/icon_dog.svg" alt=""/>
                          <p class="bar-text">依你的退休期待<br>我們建議的配比</p>
                          <i
                              class="fas fa-question"
                              :content="recommend.tip"
                              v-tippy="{arrow : true, arrowType : 'round', placement: 'bottom', allowHTML: true}"
                          >
                          </i>
                        </div>
                      </div>

                      <div class="bar-wrapper">
                        <div class="most-people--bar">
                          <div class="progress-bar stripe-blue"
                               :style="{ width: mostPeople.bar1 + '%' }"
                          >
                            {{ mostPeople.bar1 }}%
                          </div>
                          <div class="progress-bar stripe-orange"
                               :style="{ width: mostPeople.bar2 + '%' }"
                          >
                            {{ mostPeople.bar2 }}%
                          </div>
                          <div class="progress-bar stripe-red" :style="{ width: mostPeople.bar3 + '%' }"
                          >
                            {{ mostPeople.bar3 }}%
                          </div>
                        </div>

                        <div class="recommend-adjust--bar">
                          <div class="progress-bar solid-blue"
                               :style="{ width: insuranceBarPercent + '%' }"
                               :content="recommend.insurance| tip_currency"
                               v-tippy="{arrow : true, arrowType : 'round', placement: 'top'}"
                          >
                            {{ insuranceBarPercent }}%
                          </div>
                          <div class="progress-bar solid-orange"
                               v-if="savingBarPercent > 0"
                               :style="{ width: savingBarPercent + '%' }"
                               :content="recommend.saving | tip_currency"
                               v-tippy="{arrow : true, arrowType : 'round', placement: 'top'}"
                          >
                            {{ savingBarPercent }}%
                          </div>
                          <div class="progress-bar solid-red"
                               :style="{ width: dailyCostBarPercent + '%' }"
                               :content="recommend.dailyCost | tip_currency"
                               v-tippy="{arrow : true, arrowType : 'round', placement: 'top'}"
                          >
                            {{ dailyCostBarPercent }}%
                          </div>
                        </div>

                        <!-- 圖表xy軸 -->
                        <canvas class="xyAxis" ref="xyAxis"></canvas>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>

      <transition name="fade">
        <div v-show="showDetail" class="s-result__need">
          <h3>達成期待的退休生活，你可能需要...</h3>
          <div class="container">
            <carousel
                v-show="recommend.showExtraException"
                :loop="false"
                :margin="10"
                :nav="false"
                :dots="true"
                :responsive="recommend.fourItemsRwd">
              <div class="s-result__need-item">
                <img class="neee-item__img" src="@/assets/images/needs/banner-retire/icon_dress.svg" alt=""/>
                <h4>調整目前收支配比</h4>
                <p>如：少買幾件衣服</p>
              </div>

              <div class="s-result__need-item">
                <img class="neee-item__img" src="@/assets/images/needs/banner-retire/icon_travel.svg" alt=""/>
                <h4>調整對退休的期待</h4>
                <p>如：從每年出國 4 次改為 1 次</p>
              </div>

              <div class="s-result__need-item">
                <img class="neee-item__img" src="@/assets/images/needs/banner-retire/icon_healthy.svg" alt=""/>
                <h4>規劃完整的保障</h4>
                <p>確保自己不會因任何意外或身體狀況導致資產瞬減</p>
              </div>

              <div class="s-result__need-item">
                <img class="neee-item__img" src="@/assets/images/needs/banner-retire/icon_money.svg" alt=""/>
                <h4>理財與儲蓄</h4>
                <p>找到保本保息的商品，增加財富累積</p>
              </div>
            </carousel>

            <carousel
                v-show="!recommend.showExtraException"
                :loop="false"
                :margin="10"
                :nav="false"
                :dots="true"
                :responsive="recommend.twoItemsRwd">

              <div class="s-result__need-item">
                <img class="neee-item__img" src="@/assets/images/needs/banner-retire/icon_healthy.svg" alt=""/>
                <h4>規劃完整的保障</h4>
                <p>確保自己不會因任何意外或身體狀況導致資產瞬減</p>
              </div>

              <div class="s-result__need-item">
                <img class="neee-item__img" src="@/assets/images/needs/banner-retire/icon_money.svg" alt=""/>
                <h4>理財與儲蓄</h4>
                <p>找到保本保息的商品，增加財富累積</p>
              </div>
            </carousel>
          </div>
        </div>
      </transition>

      <transition name="fade">
        <div v-show="showDetail">
          <svg preserveAspectRatio="none" viewBox="0 0 100 102" height="75" width="100%" version="1.1"
               xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0 L50 100 L100 0 Z" fill="#f2f2f2" stroke="#f2f2f2"></path>
          </svg>
        </div>
      </transition>

      <div
          class="s-result_sup"
          v-if="result.stillLackAmount/((result.formData_estimateRetireAge - result.formData_currentAge)* 12) > 1500"
      >
        <div class="container">
          <h3>你的退休缺口，這樣補就對了</h3>
          <p>想實現退休藍圖，現在開始著手吧！<br/>快看看我們為你精心挑選的方案</p>
          <div class="sup_part">
            <carousel
                class="owl-theme"
                :responsive="plan.planRWD"
                :loop="false"
                :margin="10"
                :nav="false"
                :dots="true">
              <div class="sup_block_wrap item">
                <div class="sup_block bg--blue">
                  <h4>方案一</h4>
                  <div class="sup_block--w">
                    <div class="sup_block__top">
                      <div class="retire_currency_sticker">
                        <div class="retire_currency_tip USD">
                          美元保單
                        </div>
                      </div>
                      <div class="sup_block__excel" @click="showExcel1 = !showExcel1">
                        $簡易試算表
                      </div>
                    </div>

                    <div class="sup_rate">
                      <h5>報酬率</h5>
                      <span class="rate_gap">{{ h_returnRate }}%</span>
                      <br>
                      <p class="rate_name">
                        {{ h_productName }}
                      </p>
                    </div>
                    <div class="sup_count">
                      <div class="count_each">
                        <p class="count_each--item">每月繳費金額</p>
                        <p class="count_each--num">
                          {{ ~~(result.h_amount / 12) | currency }}
                          <span> 元</span>
                        </p>
                      </div>

                      <div class="count_each">
                        <p class="count_each--item">繳多久</p>
                        <p class="count_each--num">
                          {{ result.h_payYear | currency }}
                          <span> 年</span>
                        </p>
                      </div>

                      <div class="count_each">
                        <p class="count_each--item">
                          {{ result.h_remark }}
                        </p>
                        <p class="count_each--num">
                          {{ result.h_getAmount | currency }}
                          <span> 元</span>
                        </p>
                      </div>
                    </div>

                    <div class="share_btn share_btn_blueDefault custom-btn">
                      <a class="click_needs_analysis_consultPlan_1" @click.prevent="toForm('方案一（美元保單）')">我想了解</a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="sup_block_wrap item">
                <div class="sup_block bg--blue">
                  <h4>方案二</h4>
                  <div class="sup_block--w">
                    <div class="sup_block__top">
                      <div class="retire_currency_sticker">
                        <div class="retire_currency_tip NTD">
                          台幣保單
                        </div>
                      </div>
                      <div class="sup_block__excel" @click="showExcel2 = !showExcel2">
                        $簡易試算表
                      </div>
                    </div>

                    <div class="sup_rate">
                      <h5>報酬率</h5>
                      <span class="rate_gap">{{ p_returnRate }}%</span>
                      <br>
                      <p class="rate_name">
                        {{ p_productName }}
                      </p>
                    </div>
                    <div class="sup_count">
                      <div class="count_each">
                        <p class="count_each--item">每月繳費金額</p>
                        <p class="count_each--num">
                          {{ ~~(result.p_amount / 12) | currency }}
                          <span> 元</span>
                        </p>
                      </div>

                      <div class="count_each">
                        <p class="count_each--item">繳多久</p>
                        <p class="count_each--num">
                          {{ result.p_payYear | currency }}
                          <span> 年</span>
                        </p>
                      </div>

                      <div class="count_each">
                        <p class="count_each--item">
                          {{ result.p_remark }}
                        </p>
                        <p class="count_each--num">
                          {{ result.p_getAmount | currency }}
                          <span> 元</span>
                        </p>
                      </div>
                    </div>

                    <div class="share_btn share_btn_blueDefault custom-btn">
                      <a class="click_needs_analysis_consultPlan_2" @click.prevent="toForm('方案二（台幣保單）')">
                        我想了解
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="sup_block_wrap bigpresentmod item">
                <div class="sup_block">
                  <h4>方案三</h4>
                  <div class="retire_sup_block--w">
                    <div class="content_layout">
                      <div class="center_img">
                        <img src="@/assets/images/needs/banner-house/support.svg" alt="">
                      </div>
                      <p class="retire_count_each--text" style="padding-bottom:30px;">利用上述的試算結果，搭配專人的客觀分析，必定能為你找出實踐理想退休的最合適方法！</p>
                      <div class="custom-btn share_btn share_btn_blueDefault">
                        <a class="click_needs_analysis_consultPlan_3" @click="toForm('方案三')">我想了解</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </carousel>

          </div>
        </div>
      </div>


      <div
          id="s-result_sup"
          class="retire_s-result_sup"
          v-else
      >
        <div class="container">
          <h3>你的退休缺口，這樣補就對了</h3>
          <p>想實現退休藍圖，現在開始著手吧！<br/>快看看我們為你精心挑選的方案</p>
          <div class="retire_sup_part">
            <carousel
                class="owl-theme"
                :responsive="plan.planRWD"
                :loop="false"
                :margin="10"
                :nav="false"
                :dots="true">
              <div class="retire_sup_block_wrap item">
                <div class="retire_sup_block">
                  <h4>方案一</h4>
                  <div class="retire_sup_block--w retire_savemod">
                    <div class="retire_currency_sticker">
                      <div class="retire_currency_tip RCD">
                        推薦保單
                      </div>
                    </div>

                    <div class="retire_sup_rate">
                      <p>此方案年保費</p>
                      <span class="retire_rate_gap">{{ result.premium_1 | currency }}</span>

                    </div>
                    <div class="retire_sup_count">
                      <div class="retire_count_each">
                        <p class="retire_count_each--item">{{ insurance_1 }}</p>
                        <p class="retire_count_each--num">{{ h_premium_1 | currency }}<span> 元</span>
                        </p>
                      </div>
                      <div class="retire_count_each">
                        <p class="retire_count_each--item">{{ insurance_2 }}</p>
                        <p class="retire_count_each--num">{{ h_premium_2 | currency }}<span> 元</span>
                        </p>
                      </div>
                      <div class="retire_count_each">
                        <p class="retire_count_each--item">{{ insurance_3 }}</p>
                        <p class="retire_count_each--num">{{ h_premium_3 | currency }}<span> 元</span>
                        </p>
                      </div>
                      <div
                          :class="['retire_count_each', 'reasonmod', {'text-open': textOpen.plan1}]"
                          @click="textOpen.plan1 = !textOpen.plan1">
                        <p class="retire_count_each--item">方案說明</p>
                        <p class="retire_count_each--num"><i class="fas fa-chevron-down"></i>
                        <p>
                        <p class="retire_count_each--text">
                          此方案的保障完整度相當高。退休金準備足夠的你，更要將未來的人身風險儘早考慮進來，很多時候我們並非沒有為退休生活做準備，而是人生路上有各種未知的狀況，會蠶食多年來努力累積的資產，所以規劃自身足夠的保障，抵擋人生意外與風險，勢在必行。
                        </p>
                      </div>
                    </div>

                    <div
                        class="custom-btn share_btn share_btn_blueDefault">
                      <a class="click_needs_analysis_consultPlan_1" @click="toForm('方案一（完整保障）', product_id_1)">我想了解</a>
                    </div>


                  </div>
                </div>
              </div>
              <div class="retire_sup_block_wrap item">
                <div class="retire_sup_block">
                  <h4>方案二</h4>
                  <div class="retire_sup_block--w retire_savemod">
                    <div class="retire_currency_sticker">
                      <div class="retire_currency_tip RCD">
                        推薦保單
                      </div>
                    </div>

                    <div class="retire_sup_rate">
                      <p>此方案年保費</p>
                      <span class="retire_rate_gap">{{ result.premium_2 | currency }}</span>

                    </div>
                    <div class="retire_sup_count">
                      <div class="retire_count_each">
                        <p class="retire_count_each--item">{{ insurance_1 }}</p>
                        <p class="retire_count_each--num">{{ p_premium_1 | currency }}<span> 元</span>
                        </p>
                      </div>
                      <div class="retire_count_each">
                        <p class="retire_count_each--item">{{ insurance_2 }}</p>
                        <p class="retire_count_each--num">{{ p_premium_2 | currency }}<span> 元</span>
                        </p>
                      </div>
                      <div class="retire_count_each">
                        <p class="retire_count_each--item">{{ insurance_3 === '意外身故' ? '重度癌症一次金' : insurance_3 }}</p>
                        <p class="retire_count_each--num">{{ p_premium_3 | currency }}<span> 元</span>
                        </p>
                      </div>
                      <div :class="['retire_count_each', 'reasonmod', {'text-open': textOpen.plan2}]"
                           @click="textOpen.plan2 = !textOpen.plan2">
                        <p class="retire_count_each--item">方案說明</p>
                        <p class="retire_count_each--num"><i class="fas fa-chevron-down"></i>
                        <p>
                        <p class="retire_count_each--text">
                          此方案具備了基本的人身保障。準備了相對足夠的退休金後，也別忘了將意外與未知的風險考慮進規劃中，即便沒有萬貫家財那也無妨，此方案使我們仍舊可以運用有限的預算，讓各方面的保障都達成基本的水準。
                        </p>
                      </div>
                    </div>
                    <div class="custom-btn share_btn share_btn_blueDefault">
                      <a class="click_needs_analysis_consultPlan_2" @click="toForm('方案二（基本保障）')">我想了解</a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="retire_sup_block_wrap bigpresentmod item">
                <div class="retire_sup_block">
                  <h4>方案三</h4>
                  <div class="retire_sup_block--w">
                    <div class="center_layout">
                      <div class="center_img">
                        <img src="@/assets/images/needs/banner-house/support.svg" alt="">
                      </div>
                      <p class="retire_count_each--text">
                        利用上述的試算結果，搭配專人的客觀分析，必定能為你找出實踐理想退休的最合適方法！
                      </p>
                      <div class="custom-btn share_btn share_btn_blueDefault">
                        <a class="click_needs_analysis_consultPlan_3" @click="toForm('方案三')">我想了解</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </carousel>
          </div>
        </div>
      </div>

    </div>
    <!-- 試算表1 -->
    <div v-show="showExcel1">
      <popup_excel
          :json_apiCalFormList="result.h_apiCalFormList"
          :payYear="result.h_payYear"
          :retireYear="retireYear"
          :isUSD="true"
          @close="closePopupExcel1">
        <template #title>
          <h1>簡易試算表</h1>
        </template>
        <template #content>
          <p>
            簡易試算表1的內容
          </p>
        </template>
      </popup_excel>
    </div>
    <!-- 試算表2 -->
    <div v-show="showExcel2">
      <popup_excel
          :json_apiCalFormList="retireResult.p_apiCalFormList"
          :payYear="result.h_payYear"
          :retireYear="retireYear"
          @close="closePopupExcel2">
        <template #title>
          <h1>簡易試算表</h1>
        </template>
        <template #content>
          <p>
            簡易試算表2的內容
          </p>
        </template>
      </popup_excel>
    </div>
  </div>
</template>

<script>
import '@/assets/css/scenario_retire.css';
import month_cost from '@/components/month_cost';
import popup_excel from '@/components/common/popup_excel.vue';
import carousel from 'vue-owl-carousel'
import {get, sync, call} from 'vuex-pathify';

export default {
  name: 'retire_result',
  components: {month_cost, popup_excel, carousel},
  data: function () {
    return {
      travel: 100000,
      trans: 25000,
      food: 25000,
      normal: 15000,
      result: {},
      isLoading: false,
      averageLife: {
        MALE: 78,
        FEMALE: 84,
      },
      showDetail: false,
      showExcel1: false,
      showExcel2: false,
      mostPeople: {
        bar1: 10,
        bar2: 30,
        bar3: 60,
      },
      recommend: {
        insurance: 0,
        saving: 0,
        dailyCost: 0,
        tip: '',
        showExtraException: false,
        fourItemsRwd: {
          0: {
            items: 1,
            mouseDrag: true,
            touchDrag: true,
            dots: true,
          },
          768: {
            items: 2,
            mouseDrag: true,
            touchDrag: true,
            dots: true,
          },
          1200: {
            items: 4,
            loop: false,
            mouseDrag: false,
            touchDrag: false,
            dots: false,
          },
        },
        twoItemsRwd: {
          0: {
            items: 1,
            mouseDrag: true,
            touchDrag: true,
            dots: true,
          },
          768: {
            items: 2,
            mouseDrag: true,
            touchDrag: true,
            dots: false,
          },
          1200: {
            items: 2,
            loop: false,
            mouseDrag: false,
            touchDrag: false,
            dots: false,
          },
        }
      },
      plan: {
        planRWD: {
          0: {
            items: 1,
            mouseDrag: true,
            touchDrag: true,
            dots: true,
          },
          768: {
            items: 2,
            mouseDrag: true,
            touchDrag: true,
            dots: true,
          },
          1200: {
            items: 3,
            loop: false,
            mouseDrag: false,
            touchDrag: false,
            dots: false,
          },
        },
      },
      textOpen: {
        plan1: false,
        plan2: false
      }
    };
  },
  methods: {
    async updateResult(monthTotalCost) {
      this.travel = monthTotalCost.travel;
      this.trans = monthTotalCost.trans;
      this.food = monthTotalCost.food;
      this.normal = monthTotalCost.normal;
      let wantCost = this.travel + this.trans + this.food + this.normal;
      let data = {
        currentAge: this.retireResult.formData_currentAge,
        gender: this.retireResult.formData_gender,
        startWorkAge: this.retireResult.formData_startWorkAge,
        estimateRetireAge: this.retireResult.formData_estimateRetireAge,
        currentSalary: this.retireResult.formData_currentSalary,
        alreadyPrepare: this.retireResult.formData_alreadyPrepare,
        wantCostAfterRetirePerMonth: wantCost,
      };
      let update = {
        token: this.$route.params.token,
        food_normalCost: this.food,
        trans_normalCost: this.trans,
        formData_interestsCost: this.normal,
        formData_travelCost: this.travel,
      };
      await store.set('retire/sendRetireApi!', data);
      const res = await store.set('retire/updateSBApi!', update);
      if (res) history.go(0);
    },
    async setResultData() {
      let token = this.$route.params.token;
      await store.set('retire/getSBApi!', token);
      this.result = store.get('retire/result');
      this.result.retireNeedMonth = this.getRetireNeedMonth;
      this.result.retireDoneRate = Math.round(
          ((
                  this.result.formData_alreadyPrepare +
                  this.result.laborProtectionAmount +
                  this.result.laborRebateAmount) /
              this.result.costAfterRetire) * 100
      );
      if (this.result.h_currency === 'USD') {
        this.result.h_amount = this.result.h_amount * 28;
        this.result.h_getAmount = this.result.h_getAmount * 28;
        this.result.h_currency = 'NTD';
      }
      if (this.result.p_currency === 'USD') {
        this.result.p_amount = this.result.p_amount * 28;
        this.result.p_getAmount = this.result.p_getAmount * 28;
        this.result.p_currency = 'NTD';
      }
      if (this.result.h_remark === '退休後每年可領') {
        this.result.h_LackRate = Math.round(
            (((this.averageLife[this.result.formData_gender] - this.result.formData_estimateRetireAge) * this.result.h_getAmount) /
                this.result.stillLackAmount) *
            100
        );
      } else if (this.result.h_remark === '退休後可一次領') {
        this.result.h_LackRate = Math.round((this.result.h_getAmount / this.result.stillLackAmount) * 100);
      }

      if (this.result.p_remark === '退休後每年可領') {
        this.result.p_LackRate = Math.round(
            (((this.averageLife[this.result.formData_gender] - this.result.formData_estimateRetireAge) * this.result.p_getAmount) /
                this.result.stillLackAmount) *
            100
        );
      } else if (this.result.p_remark === '退休後可一次領') {
        this.result.p_LackRate = Math.round((this.result.p_getAmount / this.result.stillLackAmount) * 100);
      }
      this.setScenarioresultChart();
    },
    setScenarioresultChart() {
      let ctx = document.getElementById('ScenarioresultChart');
      let ScenarioresultChart = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: ['補足退休金額應再存', '已備退休金', '勞保', '勞退'],
          datasets: [
            {
              label: '# of Tomatoes',
              data: [
                this.getRetireNeed,
                this.result.formData_alreadyPrepare,
                this.result.laborProtectionAmount,
                this.result.laborRebateAmount,
              ],
              backgroundColor: ['#766B5C', '#FB9702', '#2693A2', '#62C4D3'],
              borderWidth: 1,
            },
          ],
        },
        options: {
          responsive: false,

          legend: {
            display: false,
          },
          tooltips: {
            titleFontSize: 16,
            bodyFontSize: 16,
            callbacks: {
              label: function (tooltipItem, data) {
                let dataLabel = data.labels[tooltipItem.index];
                let value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString();
                if (Chart.helpers.isArray(dataLabel)) {
                  dataLabel = dataLabel.slice();
                  dataLabel[0] += value;
                } else {
                  dataLabel += value;
                }

                return dataLabel + '元';
              }
            }
          }
        }
      });
    },
    backRetireForm() {
      //假如有送出過表單裡的其中一項
      try {
        if (store.get('retire@formData.payType') !== undefined) {
          let show = {
            retire_1: false,
            retire_2: false,
            retire_3: false,
            retire_4: false,
            retire_5: false,
            retire_form: true,
          };
          store.set('retire/defaultShow!', show);
        }
      } catch (e) {
        let defaultShow = {
          retire_1: true,
          retire_2: false,
          retire_3: false,
          retire_4: false,
          retire_5: false,
          retire_form: false,
        };
        store.set('retire/defaultShow!', defaultShow);
      }
      // 使用直接頁面跳轉而非 router.push
      window.location.href = '/needs_analysis/retire';
    },
    async toForm(option) {
      let update = {
        token: this.$route.params.token,
        food_normalCost: this.food,
        trans_normalCost: this.trans,
        formData_interestsCost: this.normal,
        formData_travelCost: this.travel,
      };

      await store.set('retire/setFormPlan!', option);
      await store.set('retire/updateSBApi!', update).then((res) => {
        if (res) {
          // 這裡已經是使用 window.location，不需要修改
          window.location = `/form/order/needs_analysis/retire?tk=${this.$route.params.token}`;
        }
      });
    },
    openAddPopup(id) {
      $(id).fadeIn(500);
    },
    closeAddPopup(id) {
      $(id).fadeOut(500);
    },
    setAdjustDetail() {
      this.food = this.retireResult.food_normalCost;
      this.travel = this.retireResult.formData_travelCost;
      this.normal = this.retireResult.formData_interestsCost;
      this.trans = this.retireResult.trans_normalCost;
    },
    closePopupExcel1() {
      this.showExcel1 = !this.showExcel1;
    },
    closePopupExcel2() {
      this.showExcel2 = !this.showExcel2;
    },
    drawXYAxis() {
      let ctx = this.$refs.xyAxis.getContext('2d');
      let xyAxis = new Chart(ctx, {
        type: 'line',
        data: {
          labels: ['10%', '20%', '30%', '40%', '50%', '60%', '70%', '80%', '90%', '100%'],
        },
        options: {
          maintainAspectRatio: true,
          scales: {
            xAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
                gridLines: {
                  display: false,
                },
              },
            ],
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  display: false,
                },
                gridLines: {
                  display: false,
                },
              },
            ],
          },
        },
      });
    },
    setBarTipValue() {
      let currentSalary = Math.round(this.result.formData_currentSalary)
      let savingRecommend = this.result.stillLackAmount /
          ((this.result.formData_estimateRetireAge -
              this.result.formData_currentAge) * 12)

      if (savingRecommend > this.result.formData_currentSalary * 0.45) {
        this.recommend.insurance = Math.round(this.result.formData_currentSalary * 0.1)
        this.recommend.saving = Math.round(this.result.formData_currentSalary * 0.45)
        this.recommend.showExtraException = true
        this.recommend.tip = `<div style="text-align: left; padding: 1em">許多人和你一樣！距離「理想退休生活」還有一段漫漫長路。我們除了要開源，更需要省視收支配比，把辛苦錢有方法的存下來。</div>`
      } else {
        this.recommend.insurance = Math.round(this.result.formData_currentSalary * 0.1)
        this.recommend.saving = savingRecommend > this.result.formData_currentSalary * 0.2 ? Math.round(savingRecommend) : ~~(this.result.formData_currentSalary * 0.2)
        this.recommend.tip = `<div style="text-align: left; padding: 1em">恭喜～ 依照你目前的勞保、勞退與儲蓄，只要好好堅持下去，距離「理想退休生活」也不遠了（羨慕貌）<br>但在考量勞保可能破產的情況下，建議你還是多存點錢，並提高自己的人身保障，這絕對是「有保有保祐」啦！</div>`
      }

      this.recommend.dailyCost = currentSalary - this.recommend.insurance - this.recommend.saving
    },
    defineThreeAgeValue(thirty, fortyFour, older) {
      if (this.result.formData_currentAge <= 30) {
        return thirty
      } else if (this.result.formData_currentAge <= 45) {
        return fortyFour
      }
      return older
    }
  },
  computed: {
    ...get('retire', {
      retireResult: 'result',
      getRetireNeedMonth: 'getRetireNeedMonth',
      getRetireNeed: 'getRetireNeed',
    }),
    h_productName() {
      if (typeof this.result.selectedProduct === 'string') {
        return JSON.parse(this.result.selectedProduct).plan1
      }
    },
    p_productName() {
      if (typeof this.result.selectedProduct === 'string') {
        return JSON.parse(this.result.selectedProduct).plan2
      }
    },
    retireYear() {
      let retireYear = this.result.formData_estimateRetireAge - this.result.formData_currentAge
      if (typeof (retireYear) === 'number') return retireYear
    },
    insuranceBarPercent() {
      let currentSalary = Math.round(this.result.formData_currentSalary)
      return Math.round(this.recommend.insurance / currentSalary * 100)
    },
    savingBarPercent() {
      let currentSalary = Math.round(this.result.formData_currentSalary)
      return Math.round(this.recommend.saving / currentSalary * 100)
    },
    dailyCostBarPercent() {
      return 100 - this.insuranceBarPercent - this.savingBarPercent
    },
    h_returnRate() {
      if (this.result.h_apiCalFormList) {
        let parsedApiCalFormList = JSON.parse(this.result.h_apiCalFormList)
        let calFormItem = parsedApiCalFormList.find((item) => item.year === this.retireYear)

        return Math.round((calFormItem.cancelPremium -
                calFormItem.totalPaymentPremium) /
            calFormItem.totalPaymentPremium * 100
        )
      }
    },
    p_returnRate() {
      if (this.result.p_apiCalFormList) {
        let parsedApiCalFormList = JSON.parse(this.result.p_apiCalFormList)
        let calFormItem = parsedApiCalFormList.find((item) => item.year === this.retireYear)

        return Math.round((calFormItem.cancelPremium -
                calFormItem.totalPaymentPremium) /
            calFormItem.totalPaymentPremium * 100
        )
      }
    },
    product_id_1() {
      return this.defineThreeAgeValue(
          '7f5431c5174d58d1d87d7a9a08a54f62',
          '1b61f6dd44a1a40cf4245669624227e2',
          '3101e3deabbbf9138c84235df233cb7a')
    },
    product_id_2() {
      return this.defineThreeAgeValue(
          'cefa514f21d42db85d5169cbfda1738b',
          '592ae6ff4fceebbafbffdadb3f87df3c',
          '1e289442d706773512f320c8f441c1c0')
    },
    h_premium_1() {
      return this.defineThreeAgeValue(480000, 510000, 200000)
    },
    h_premium_2() {
      return this.defineThreeAgeValue(150000, 3000000, 5000000)
    },
    h_premium_3() {
      return this.defineThreeAgeValue(2000000, 2000000, 5100000)
    },
    p_premium_1() {
      return this.defineThreeAgeValue(210000, 170000, 300000)
    },
    p_premium_2() {
      return this.defineThreeAgeValue(100000, 1500000, 1000000)
    },
    p_premium_3() {
      return this.defineThreeAgeValue(1000000, 1000000, 1000000)
    },
    insurance_1() {
      return this.defineThreeAgeValue('醫療實支實付', '醫療實支實付', '醫療實支實付')
    },
    insurance_2() {
      return this.defineThreeAgeValue('意外實支實付', '癌症一次金', '意外失能一次金')
    },
    insurance_3() {
      return this.defineThreeAgeValue('失能一次金', '失能一次金', '意外身故')
    },
  },
  filters: {
    currency(value) {
      var num = (value || 0).toString(),
          result = '';
      while (num.length > 3) {
        result = ',' + num.slice(-3) + result;
        num = num.slice(0, num.length - 3);
      }
      if (num) {
        result = num + result;
      }
      if (!result.indexOf('-,')) result = result.replace('-,', '-');
      return result;
    },
    tip_currency(value) {
      var num = (value || 0).toString(),
          result = '';
      while (num.length > 3) {
        result = ',' + num.slice(-3) + result;
        num = num.slice(0, num.length - 3);
      }
      if (num) {
        result = num + result;
      }
      if (!result.indexOf('-,')) result = result.replace('-,', '-');
      return result + ' 元/月';
    },
  },
  async created() {
    await this.setResultData();
    await this.setAdjustDetail();
    await this.setBarTipValue()
  },
};
</script>

<style scoped>
.loading {
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 99999;
}
</style>
